import React from 'react'

import Button from '../Button'

import classes from './styles'

const Welcome = ({ isLoading, start }) => (
  <div className={classes.welcome}>
    <div className={classes.logoWrapper}>
      <img className={classes.logo} src={`${process.env.PUBLIC_URL}/logo_lh.png`} alt=""/>
    </div>

    <div className={classes.content}>
      <h2 className={classes.title}>
        Ты - пикчер!
      </h2>

      <div className={classes.description}>
        Задание на сегодня — выбрать обложки для статей. Перед тобой один настоящий заголовок статьи и две обложки. Одна из них правильная — именно с ней на Лайфхакере появилась статья. Вторая — фейк, обложка от другой статьи. Задача: выбрать правильную обложку, которая подходит к заголовку (по мнению пикчеров ЛХ, конечно). Раздумывать некогда, время ограниченно.
      </div>

      <div className={classes.footer}>
        <div className={classes.controls}>
          {isLoading ?
            <Button
              disabled={true}
            >
              Ждите
            </Button>
            :
            <Button
              onClick={start}
            >
              Играть
            </Button>
          }
        </div>
      </div>
    </div>

  </div>
)

Welcome.propTypes = {
  isLoading: React.PropTypes.bool.isRequired,
  start: React.PropTypes.func.isRequired,
}

export default Welcome


// WEBPACK FOOTER //
// ./src/components/Welcome/Welcome.jsx